/* jshint esversion: 6 */
import React from 'react';
import DropDownModule from 'app/mixins/DropDownModule.js';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import classnames from 'classnames';

class FilterItem extends React.Component {
	render() {

		let iconIndex = (this.props.item.subtype) ? ConstantMixin.getIconIndexByCode(this.props.item.subtype) : ConstantMixin.getIconIndexByCode(this.props.item.type);
		let	Icon = IconFactory[iconIndex],
			itemClass = classnames('filter-item',
				{
					'active-item': this.props.itemActive
				}
			);

		return (
			<li key={this.props.key} className={itemClass} onClick={this.props.onClick}>
				<div className="filter-icon">
					<Icon key={this.props.item.type} />
				</div>
				<div className="filter-label">
					{this.props.item.name}
				</div>
				<div className="filter-count">
					{this.props.item.count}
				</div>
			</li>
		);
	}
};

export default DropDownModule(FilterItem);
